export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/leaks.0f9b6eab.svg","height":165,"width":165,"blurWidth":0,"blurHeight":0};